import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Route, Switch, withRouter } from 'react-router-dom';
import NotFound from '../NotFound';
import HoaExplorer from './HoaExplorer';

const Hoa = () => {
  const [role] = useState(localStorage.getItem('user-role'));

  const getActivePage = () => {
    return (
      <Switch>
        <Route exact path="/hoa/explorer">
          <HoaExplorer />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    );
  };
  return (
    <Container fluid className="px-2 px-md-4 py-3 h-100">
      {getActivePage()}
    </Container>
  );
};

export default withRouter(Hoa);
